export default __webpack_public_path__ + "static/media/cvMatheusGoulart2024.ed11bfa9.pdf";